<div class="html-report-shell" *ngIf="definition; else missingDef">
   <span class="hint-pill" *ngIf="isAnnotationsLoading && areRowAnnotationsEnabled()">
      Loading annotations…
   </span>

   <app-report-summary-header
      *ngIf="isReportHeaderVisible()"
      [title]="reportHeaderTitle"
      [businessDateLabel]="reportHeaderBusinessDateLabel"
      [businessDateText]="reportHeaderBusinessDateText"
      [snippets]="reportHeaderSnippets"
      [totalReportValueText]="reportHeaderTotalReportValueText"
   ></app-report-summary-header>

   <app-report-risk-summary
      *ngIf="!isPmsDataStatusBlockingReportRender()"
      [reportData]="reportData"
   ></app-report-risk-summary>

   <div
      class="report-pms-status-message"
      [ngClass]="getPmsDataStatusMessageClass()"
      *ngIf="isPmsDataStatusBlockingReportRender()"
   >
      <div class="status-icon">
         <i class="pi pi-info-circle"></i>
      </div>

      <div class="status-content">
         <div class="status-title">
            {{ getPmsDataStatusMessageTitle() }}
         </div>
         <div class="status-body">
            {{ getPmsDataStatusMessageBody() }}
         </div>
      </div>
   </div>

   <div
      class="report-layout-switcher"
      *ngIf="!isPmsDataStatusBlockingReportRender() && hasMultipleLayouts()"
   >
      <button
         type="button"
         class="report-layout-button"
         *ngFor="let layout of definition?.layouts"
         [class.active]="layout.id === activeLayoutId"
         (click)="selectLayout(layout.id)"
      >
         {{ layout.label }}
      </button>
   </div>

   <div
      class="report-annotation-disabled-message"
      *ngIf="
         !isPmsDataStatusBlockingReportRender() &&
         isRowAnnotationDisabledNoticeVisible()
      "
   >
      <i class="pi pi-info-circle"></i>
      <span>{{ getRowAnnotationDisabledMessage() }}</span>
   </div>

   <div
      class="report-toolbar"
      *ngIf="!isPmsDataStatusBlockingReportRender() && getFilterFields().length"
   >
      <div class="header-actions">
         <button
            *ngIf="hasActiveSort()"
            type="button"
            class="sort-reset-button"
            (click)="clearSort()"
         >
            <i class="pi pi-refresh"></i>
            Reset Sort
         </button>

         <button
            type="button"
            class="filter-toggle"
            (click)="toggleFilterPanel(); addFirstFilterIfEmpty()"
         >
            <i class="pi pi-filter"></i>
            Filters
            <span class="count" *ngIf="activeFilterCount > 0">
               {{ activeFilterCount }}
            </span>
         </button>

         <button
            type="button"
            class="filter-clear"
            *ngIf="filterCriteria.length"
            (click)="clearFilters()"
         >
            Clear
         </button>

         <button
            type="button"
            class="filter-apply"
            *ngIf="filterCriteria.length"
            (click)="applyFilters()"
         >
            Apply
         </button>
      </div>
   </div>

   <!-- Filter Panel (now outside header + full width) -->
   <div
      class="filter-panel flex"
      *ngIf="
         !isPmsDataStatusBlockingReportRender() &&
         isFilterOpen &&
         getFilterFields().length
      "
   >
      <div
         class="filter-row"
         [ngClass]="{ 'has-between': isBetween(c.operator) }"
         *ngFor="let c of filterCriteria; let i = index"
      >
         <!-- JOIN column -->
         <div class="filter-cell join">
            <ng-container *ngIf="i > 0; else whereLabel">
               <p-dropdown
                  [options]="joinOptions"
                  [(ngModel)]="c.joinWithPrev"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="filter-dd"
               ></p-dropdown>
            </ng-container>

            <ng-template #whereLabel>
               <span class="where-pill">WHERE</span>
            </ng-template>
         </div>

         <!-- Field -->
         <div class="filter-cell">
            <p-dropdown
               class="filter-dd-host"
               [options]="getFilterFields()"
               [(ngModel)]="c.fieldKey"
               (onChange)="onFieldChanged(c)"
               optionLabel="label"
               optionValue="key"
               placeholder="Field..."
               styleClass="filter-dd"
            ></p-dropdown>
         </div>

         <!-- Operator -->
         <div class="filter-cell op">
            <p-dropdown
               class="filter-dd-host"
               [options]="getOperatorsForField(c.fieldKey)"
               [(ngModel)]="c.operator"
               (onChange)="onOperatorChanged(c)"
               optionLabel="label"
               optionValue="value"
               placeholder="Operator..."
               styleClass="filter-dd"
            ></p-dropdown>
         </div>

         <!-- Value -->
         <div
            class="filter-cell value"
            *ngIf="c.operator !== 'isEmpty' && c.operator !== 'isNotEmpty'"
         >
            <input
               *ngIf="getFieldType(c.fieldKey) !== 'date'"
               [type]="getFieldType(c.fieldKey) === 'number' ? 'number' : 'text'"
               [(ngModel)]="c.value"
               placeholder="Value"
               styleClass="filter-dd"
            />
            <p-calendar
               *ngIf="getFieldType(c.fieldKey) === 'date'"
               class="filter-cal-host"
               styleClass="filter-cal"
               [(ngModel)]="c.value"
               dateFormat="dd/mm/yy"
               [showIcon]="true"
               [iconDisplay]="'input'"
               [appendTo]="'body'"
            ></p-calendar>
         </div>

         <!-- ValueTo -->
         <div class="filter-cell valueTo" *ngIf="isBetween(c.operator)">
            <input
               *ngIf="getFieldType(c.fieldKey) !== 'date'"
               [type]="getFieldType(c.fieldKey) === 'number' ? 'number' : 'text'"
               [(ngModel)]="c.valueTo"
               placeholder="And…"
            />
            <p-calendar
               *ngIf="getFieldType(c.fieldKey) === 'date'"
               class="filter-cal-host"
               styleClass="filter-cal"
               [(ngModel)]="c.valueTo"
               dateFormat="dd/mm/yy"
               [showIcon]="true"
               [iconDisplay]="'input'"
               [appendTo]="'body'"
            ></p-calendar>
         </div>

         <!-- Actions -->
         <div class="filter-cell actions">
            <button
               type="button"
               class="icon-btn"
               (click)="addFilterAfter(i)"
               title="Add filter"
            >
               <i class="pi pi-plus"></i>
            </button>

            <button
               type="button"
               class="icon-btn danger"
               (click)="removeFilter(i)"
               title="Remove filter"
               [disabled]="filterCriteria.length === 1"
            >
               <i class="pi pi-times"></i>
            </button>
         </div>
      </div>
   </div>

   <ng-container *ngIf="!isPmsDataStatusBlockingReportRender()">
      <div class="report-row-legend" *ngIf="showRowLegend()">
         <div class="report-row-legend-item" *ngIf="hasRowRisks()">
            <span class="legend-risk-indicator" aria-hidden="true">
               <i class="pi pi-exclamation-triangle"></i>
            </span>
            <span class="report-row-legend-label">Risk</span>
            <span class="report-row-legend-description">
               A coloured edge shows severity when supplied.
            </span>
         </div>

         <div
            class="report-row-legend-item"
            *ngIf="areRowAnnotationsEnabled()"
         >
            <span class="legend-manual-highlight" aria-hidden="true"></span>
            <span class="report-row-legend-label">Manual highlight</span>
            <span class="report-row-legend-description">
               Added by a user by double-clicking the row.
            </span>
         </div>
      </div>

      <div class="table-wrap">
				<table
					class="report-table"
					[style.min-width]="getActiveTableMinWidth()"
				>
            <!-- =======================
					 ADD HERE: Column widths
					 ======================= -->
            <colgroup>
							<col class="risk-indicator-col" />
							<col
								*ngIf="isRowDetailsEnabled()"
								class="row-details-toggle-col"
							/>
							<col *ngIf="isRowChecksEnabled()" style="width: 44px" />
               <col *ngIf="areRowAnnotationsEnabled()" style="width: 44px" />
            </colgroup>

            <thead>
               <tr>
                  <th class="risk-indicator-header">
                     <span class="visually-hidden">Risk</span>
                  </th>
								 <th
									 *ngIf="isRowDetailsEnabled()"
									 class="row-details-toggle-header"
								 >
									 <span class="visually-hidden">Reservation details</span>
								 </th>
                  <th class="row-check-col" *ngIf="isRowChecksEnabled()">
                     <input
                        type="checkbox"
                        [checked]="areAllVisibleCheckableRowsChecked()"
                        [indeterminate]="
                           isSomeVisibleCheckableRowChecked() &&
                           !areAllVisibleCheckableRowsChecked()
                        "
                        [disabled]="!getVisibleCheckableRows().length"
                        (click)="$event.stopPropagation()"
                        (change)="toggleAllVisibleCheckedRows($event)"
                        title="Check / uncheck all visible rows"
                     />
                  </th>

                  <th
                     *ngFor="let col of activeColumns"
                     [class.sortable-column]="isColumnSortable(col)"
                     [class.sorted-column]="isColumnSorted(col)"
                     [attr.aria-sort]="getColumnAriaSort(col)"
                  >
                     <button
                        *ngIf="isColumnSortable(col); else plainHeader"
                        type="button"
                        class="sort-header-button"
                        (click)="onSortColumn(col)"
                     >
                        <span class="sort-header-label">{{ col.header }}</span>
                        <i [ngClass]="getSortIconClass(col)"></i>
                     </button>

										<ng-template #plainHeader>
											<span class="sort-header-label">{{ col.header }}</span>
										</ng-template>
                  </th>

                  <th class="comment-col" *ngIf="areRowAnnotationsEnabled()"></th>
               </tr>
            </thead>

					<tbody>
					<ng-container
						*ngFor="let row of visibleRows; trackBy: trackByRowId"
					>
						<tr
							(dblclick)="onRowDoubleClick(row)"
							[ngClass]="getRowClass(row)"
							[class.row-details-expanded]="isRowDetailsExpanded(row)"
							[style.background]="getHighlightColor(row.rowId) || ''"
						>
							<td class="risk-indicator-cell">
            <span
							*ngIf="row.risk?.hasRisk"
							class="row-risk-indicator"
							role="img"
							[attr.title]="getRowRiskTooltip(row)"
							[attr.aria-label]="getRowRiskTooltip(row)"
						>
               <i
								 class="pi pi-exclamation-triangle"
								 aria-hidden="true"
							 ></i>
            </span>
							</td>

							<td
								*ngIf="isRowDetailsEnabled()"
								class="row-details-toggle-cell"
							>
								<button
									*ngIf="isRowDetailsAvailable(row)"
									type="button"
									class="row-details-toggle-button"
									[attr.aria-expanded]="isRowDetailsExpanded(row)"
									[attr.title]="
                  isRowDetailsExpanded(row)
                     ? 'Hide reservation details'
                     : 'Show reservation details'
               "
									(click)="toggleRowDetails(row, $event)"
									(dblclick)="$event.stopPropagation()"
								>
									<i
										[ngClass]="
                     isRowDetailsExpanded(row)
                        ? 'pi pi-chevron-down'
                        : 'pi pi-chevron-right'
                  "
										aria-hidden="true"
									></i>
									<span class="visually-hidden">
                  {{
											isRowDetailsExpanded(row)
												? 'Hide reservation details'
												: 'Show reservation details'
										}}
               </span>
								</button>
							</td>

							<td
								class="row-check-col"
								*ngIf="isRowChecksEnabled()"
							>
								<input
									*ngIf="isRowCheckable(row)"
									type="checkbox"
									[checked]="isRowChecked(row)"
									(click)="$event.stopPropagation()"
									(dblclick)="$event.stopPropagation()"
									(change)="toggleRowChecked(row, $event)"
									title="Mark row as checked"
								/>
							</td>

							<td *ngFor="let col of activeColumns">
								<div
									class="cell"
									[class.expanded]="
                  isCellExpanded(row.rowId, col.key)
               "
								>
               <span class="cell-text">
                  {{ getDisplayText(row, col) }}
               </span>

									<button
										*ngIf="isTruncatable(row, col)"
										type="button"
										class="cell-more"
										(click)="
                     toggleCell(row.rowId, col.key, $event)
                  "
										[attr.title]="
                     isCellExpanded(row.rowId, col.key)
                        ? 'Collapse'
                        : 'Expand'
                  "
									>
										...
									</button>
								</div>
							</td>

							<td
								class="comment-col"
								*ngIf="areRowAnnotationsEnabled()"
							>
								<button
									*ngIf="isRowAnnotatable(row)"
									type="button"
									class="comment-btn"
									(click)="openComment(row)"
									[attr.title]="getCommentTooltip(row.rowId)"
								>
									<i
										class="pi pi-comment"
										[ngClass]="getCommentIconClass(row.rowId)"
									></i>
								</button>
							</td>
						</tr>

						<tr
							*ngIf="isRowDetailsExpanded(row)"
							class="report-row-details-row"
						>
							<td [attr.colspan]="getTableColumnCount()">
								<div class="report-row-details-panel">
									<div class="report-row-details-heading">
										Reservation details
									</div>

									<dl class="report-row-details-grid">
										<div
											*ngFor="
                        let field of getActiveRowDetailFields()
                     "
											class="report-row-detail-item"
										>
											<dt>{{ field.label }}</dt>
											<dd>{{ getRowDetailValue(row, field) }}</dd>
										</div>
									</dl>
								</div>
							</td>
						</tr>
					</ng-container>
					</tbody>
         </table>
      </div>
   </ng-container>

	<app-report-row-comments-modal
		*ngIf="
      !isPmsDataStatusBlockingReportRender() &&
      areRowAnnotationsEnabled()
   "
		[visible]="isCommentModalVisible"
		[taskInstanceId]="taskInstanceId"
		[rowId]="activeCommentRowId"
		(visibleChange)="onCommentModalVisibleChange($event)"
		(commentAdded)="onRowCommentAdded($event)"
	></app-report-row-comments-modal>
</div>

<ng-template #missingDef>
   <div class="missing-def">
      No ReportDefinition found for reportType: <b>{{ reportType }}</b>
   </div>
</ng-template>
